"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "EnhancerContext", {
  enumerable: true,
  get: function get() {
    return _DecoratorsRoot.EnhancerContext;
  }
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _radium = _interopRequireDefault(require("radium"));

var _StoreDesign = _interopRequireDefault(require("@meepshop/context/lib/StoreDesign"));

var _withContext = _interopRequireDefault(require("@store/utils/lib/withContext"));

var _globalPopup = _interopRequireDefault(require("@meepshop/global-popup"));

var _propTypes2 = require("../constants/propTypes");

var _DecoratorsRoot = _interopRequireWildcard(require("./DecoratorsRoot"));

var _ContainerSwitch = _interopRequireDefault(require("./ContainerSwitch"));

var _dec, _class, _class2, _temp;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

require("./styles/index.less");

var styles = {
  "root": "meepshop-meep-ui__layout-index__root",
  "container": "meepshop-meep-ui__layout-index__container",
  "footer": "meepshop-meep-ui__layout-index__footer"
};
var Layout = (_dec = (0, _withContext["default"])(_StoreDesign["default"], function (_ref) {
  var colors = _ref.colors;
  return {
    colors: colors
  };
}), _dec(_class = (0, _radium["default"])(_class = (_temp = _class2 = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Layout, _React$PureComponent);

  var _super = _createSuper(Layout);

  function Layout() {
    (0, _classCallCheck2["default"])(this, Layout);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Layout, [{
    key: "render",

    /*
     * colors - the setting of the colors
     */
    value: function render() {
      var _this$props = this.props,
          isPreview = _this$props.isPreview,
          colors = _this$props.colors,
          background = _this$props.background,
          blocks = _this$props.blocks,
          container = _this$props.container,
          globalPopup = _this$props.globalPopup,
          props = (0, _objectWithoutProperties2["default"])(_this$props, ["isPreview", "colors", "background", "blocks", "container", "globalPopup"]);
      return /*#__PURE__*/_react["default"].createElement(_DecoratorsRoot["default"], props, function (_ref2) {
        var hiddingMeepshopMaxInFooterEnabled = _ref2.hiddingMeepshopMaxInFooterEnabled,
            cname = _ref2.cname;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
          className: styles.root
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: styles.container
        }, /*#__PURE__*/_react["default"].createElement(_ContainerSwitch["default"], (0, _extends2["default"])({}, props, {
          key: container,
          containerName: container,
          blocks: blocks
        }))), /*#__PURE__*/_react["default"].createElement(_globalPopup["default"], {
          isPreview: isPreview,
          globalPopup: globalPopup
        }), hiddingMeepshopMaxInFooterEnabled ? null : /*#__PURE__*/_react["default"].createElement("footer", {
          className: styles.footer
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: "https://www.meepshop.com/consultant-reservation-max?utm_source=\u6975\u901F\u958B\u5E97&utm_campaign=\u6975\u901F\u958B\u5E97_\u76F4\u9054\u9810\u7D04\u5C08\u4EBA&utm_content=".concat(cname),
          target: "_blank",
          rel: "noopener noreferrer"
        }, "meepShop \u6975\u901F\u958B\u5E97"))));
      });
    }
  }]);
  return Layout;
}(_react["default"].PureComponent), (0, _defineProperty2["default"])(_class2, "propTypes", {
  colors: _propTypes["default"].arrayOf(_propTypes2.COLOR_TYPE.isRequired).isRequired,
  background: _propTypes2.COLOR_TYPE,
  container: _propTypes["default"].oneOf(['DefaultContainer', 'FixedTopContainer', 'TwoTopsContainer', 'FixedTopContainerWithSidebar', 'TwoTopsContainerWithSidebar']).isRequired,
  blocks: _propTypes["default"].arrayOf(_propTypes["default"].shape({}).isRequired).isRequired,

  /** must be Block */
  children: _propTypes["default"].node
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  background: null,
  children: null
}), _temp)) || _class) || _class);
exports["default"] = Layout;